import { useEffect, useState } from 'react';

export const useErrorClassObserver = (): Element | null => {
  const [errorClass, setErrorClass] = useState<Element | null>(null);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const errorElement = document.querySelector('.Mui-error');
      setErrorClass(errorElement);
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Initial check
    const errorElement = document.querySelector('.Mui-error');
    setErrorClass(errorElement);

    return () => {
      observer.disconnect();
    };
  }, []);

  return errorClass;
};
